export default __webpack_public_path__ + "static/media/supplier-icon.084f67f6.svg";